import React, { useState } from 'react';
import { EnvelopeIcon, ChatBubbleLeftRightIcon, PhoneIcon, SpeakerWaveIcon } from '@heroicons/react/24/outline';

const LogsTab = ({ register, errors, watch, setValue, inputClassName, logs }) => {
  const [activeLogsTab, setActiveLogsTab] = useState('email');

  const mockEmailMessages = [];
  const mockTextMessages = [];
  const mockCallLogs = [];
  const mockVoiceReminders = [];

  // Mock data for logs
  // const mockEmailMessages = [
  //   { id: 1, subject: 'Service Appointment Confirmation', from: 'service@company.com', to: 'customer@email.com', date: '2024-02-01 10:30:00', status: 'Sent' },
  //   { id: 2, subject: 'Invoice #INV-001', from: 'billing@company.com', to: 'customer@email.com', date: '2024-01-25 14:15:00', status: 'Sent' },
  //   { id: 3, subject: 'Follow-up on Job Completion', from: 'service@company.com', to: 'customer@email.com', date: '2024-01-20 09:45:00', status: 'Delivered' }
  // ];

 
  // const mockTextMessages = [
  //   { id: 1, message: 'Your appointment is confirmed for tomorrow at 2 PM', from: '+1-555-0123', to: '+1-555-0456', date: '2024-02-01 10:30:00', status: 'Delivered' },
  //   { id: 2, message: 'Your technician is on the way. ETA: 15 minutes', from: '+1-555-0123', to: '+1-555-0456', date: '2024-01-25 14:15:00', status: 'Delivered' },
  //   { id: 3, message: 'Thank you for choosing our service. Please rate your experience', from: '+1-555-0123', to: '+1-555-0456', date: '2024-01-20 09:45:00', status: 'Sent' }
  // ];

  // const mockCallLogs = [
  //   { id: 1, type: 'Incoming', number: '+1-555-0456', duration: '5:23', date: '2024-02-01 10:30:00', notes: 'Customer called to reschedule appointment' },
  //   { id: 2, type: 'Outgoing', number: '+1-555-0456', duration: '2:15', date: '2024-01-25 14:15:00', notes: 'Follow-up call about completed service' },
  //   { id: 3, type: 'Incoming', number: '+1-555-0456', duration: '8:45', date: '2024-01-20 09:45:00', notes: 'Customer inquiry about pricing' }
  // ];

  // const mockVoiceReminders = [
  //   { id: 1, message: 'Appointment reminder for tomorrow at 2 PM', number: '+1-555-0456', date: '2024-02-01 10:30:00', status: 'Sent' },
  //   { id: 2, message: 'Payment reminder for invoice #INV-001', number: '+1-555-0456', date: '2024-01-25 14:15:00', status: 'Sent' },
  //   { id: 3, message: 'Service completion follow-up', number: '+1-555-0456', date: '2024-01-20 09:45:00', status: 'Delivered' }
  // ];

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'sent':
      case 'delivered':
        return 'bg-green-100 text-green-800';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'failed':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getCallTypeColor = (type) => {
    switch (type.toLowerCase()) {
      case 'incoming':
        return 'bg-green-100 text-green-800';
      case 'outgoing':
        return 'bg-blue-100 text-blue-800';
      case 'missed':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const renderEmailMessages = () => (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Subject
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              From
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              To
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Date
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Status
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {mockEmailMessages.length > 0 ? (
            mockEmailMessages.map((message) => (
            <tr key={message.id} className="hover:bg-gray-50">
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {message.subject}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {message.from}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {message.to}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {formatDateTime(message.date)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(message.status)}`}>
                  {message.status}
                </span>
              </td>
            </tr>
          )) 
        ) : (
          <tr>
            <td colSpan={5} className="px-6 py-4 text-center text-gray-500">No email messages found</td>
          </tr>
        )}
        </tbody>
      </table>
    </div>
  );

  const renderTextMessages = () => (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Message
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              From
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              To
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Date
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Status
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
        {mockTextMessages.length > 0 ? (
          mockTextMessages.map((message) => (
            <tr key={message.id} className="hover:bg-gray-50">
              <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">
                {message.message}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {message.from}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {message.to}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {formatDateTime(message.date)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(message.status)}`}>
                  {message.status}
                </span>
              </td>
            </tr>
          )) 
        ) : (
          <tr>
            <td colSpan={5} className="px-6 py-4 text-center text-gray-500">No text messages found</td>
          </tr>
        )}
        </tbody>
      </table>
    </div>
  );

  const renderCallLogs = () => (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Type
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Number
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Duration
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Date
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Notes
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {mockCallLogs.length > 0 ? (
          mockCallLogs.map((call) => (
            <tr key={call.id} className="hover:bg-gray-50">
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getCallTypeColor(call.type)}`}>
                  {call.type}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {call.number}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {call.duration}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {formatDateTime(call.date)}
              </td>
              <td className="px-6 py-4 text-sm text-gray-500 max-w-xs truncate">
                {call.notes}
              </td>
            </tr>
          )) 
        ) : (
          <tr>
            <td colSpan={5} className="px-6 py-4 text-center text-gray-500">No call logs found</td>
          </tr>
        )}
        </tbody>
      </table>
    </div>
  );

  const renderVoiceReminders = () => (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Message
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Number
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Date
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Status
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {mockVoiceReminders.length > 0 ? (
          mockVoiceReminders.map((reminder) => (
            <tr key={reminder.id} className="hover:bg-gray-50">
              <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">
                {reminder.message}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {reminder.number}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {formatDateTime(reminder.date)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(reminder.status)}`}>
                  {reminder.status}
                </span>
              </td>
            </tr>
          )) 
        ) : (
          <tr>
            <td colSpan={5} className="px-6 py-4 text-center text-gray-500">No voice reminders found</td>
          </tr>
        )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="space-y-8">
      {/* Customer Messages */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Customer Messages</h3>
        
        {/* Logs Tabs */}
        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-8 overflow-x-auto">
            <button
             type="button"
              onClick={() => setActiveLogsTab('email')}
              className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center ${
                activeLogsTab === 'email'
                  ? 'border-[#009efb] text-[#009efb]'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <EnvelopeIcon className="w-4 h-4 mr-2" />
              Email Messages
            </button>
            <button
             type="button"
              onClick={() => setActiveLogsTab('text')}
              className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center ${
                activeLogsTab === 'text'
                  ? 'border-[#009efb] text-[#009efb]'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <ChatBubbleLeftRightIcon className="w-4 h-4 mr-2" />
              Text Messages
            </button>
            <button
             type="button"
              onClick={() => setActiveLogsTab('calls')}
              className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center ${
                activeLogsTab === 'calls'
                  ? 'border-[#009efb] text-[#009efb]'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <PhoneIcon className="w-4 h-4 mr-2" />
              Call Logs
            </button>
            <button
             type="button"
              onClick={() => setActiveLogsTab('voice')}
              className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center ${
                activeLogsTab === 'voice'
                  ? 'border-[#009efb] text-[#009efb]'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <SpeakerWaveIcon className="w-4 h-4 mr-2" />
              Voice Reminders
            </button>
          </nav>
        </div>

        {/* Tab Content */}
        <div>
          {activeLogsTab === 'email' && renderEmailMessages()}
          {activeLogsTab === 'text' && renderTextMessages()}
          {activeLogsTab === 'calls' && renderCallLogs()}
          {activeLogsTab === 'voice' && renderVoiceReminders()}
        </div>
      </div>
    </div>
  );
};

export default LogsTab; 